import { defineMessages } from 'react-intl-next';

export const i18n: {
    frameAboveImageDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; frameAboveImageLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; imageBackgroundDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; // We will eventually use these translations when full background layout is properly introduced
    imageBackgroundLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; solidColorBackgroundDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; solidColorBackgroundLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; splitDesignContentFirstDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; splitDesignContentFirstLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    splitDesignImageFirstDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; splitDesignImageFirstLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	splitDesignContentFirstLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label',
		defaultMessage: 'Split design (content first)',
		description: 'Split design layout option label',
	},
	splitDesignContentFirstDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description',
		defaultMessage: 'Large image on the right with lots of room for content',
		description: 'Split design layout option description',
	},
	splitDesignImageFirstLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label',
		defaultMessage: 'Split design (image first)',
		description: 'Split design layout option label',
	},
	splitDesignImageFirstDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description',
		defaultMessage: 'Large image on the left with lots of room for content',
		description: 'Split design layout option description',
	},
	solidColorBackgroundLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label',
		defaultMessage: 'Solid color background',
		description: 'Solid color background layout option label',
	},
	solidColorBackgroundDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description',
		defaultMessage: 'Content in front of a full-width color',
		description: 'Solid color background layout option description',
	},
	frameAboveImageLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label',
		defaultMessage: 'Content frame inside image',
		description: 'Frame above image layout option label',
	},
	frameAboveImageDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description',
		defaultMessage: 'Text box overlay on a large image',
		description: 'Frame above image layout option description',
	},
	// We will eventually use these translations when full background layout is properly introduced
	imageBackgroundLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label',
		defaultMessage: 'Image background',
		description: 'Image background layout option label',
	},
	imageBackgroundDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description',
		defaultMessage: 'Full-size image behind your content',
		description: 'Image background layout option description',
	},
});
